import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { userProfilePayload } from './userProfile.types';

export const updateUserProfile = (client: AxiosInstance) => async (payload: userProfilePayload) => {
  return (await client.post<{ message: string }>(API_ROUTES.UPDATE_USER_PROFILE, payload)).data;
};
export const userProfileMutations = {
  updateUserProfile,
};
